<template>
  <tr>
    <td width="150px">{{author}}</td>
    <td>
      <p v-html="report"></p>
      <button type="button" name="button" class="btn btn-primary mb-2" v-on:click="showHideIdea()">{{showHideText}} reported idea</button>
      <transition name="grow">
        <Ideas v-if="showIdea" :ideas="ideaContent"></Ideas>
      </transition>
    </td>
    <td width="200px">{{reportee}}</td>
  </tr>
</template>

<script>
import Ideas from '@/components/Ideas'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  props: [
    'author',
    'report',
    'reportee',
    'ideaID'
  ],
  components: {
    Ideas
  },
  data () {
    return {
      showIdea: false,
      ideaContent: []
    }
  },
  computed: {
    showHideText: function () {
      if (this.showIdea) {
        return 'Hide'
      } else {
        return 'Show'
      }
    }
  },
  methods: {
    loadIdea: function () {
      WordpressRestAPI.getViewContent('idea/' + this.ideaID + '?_embed')
        .then(response => {
          this.ideaContent.push(response.data)
          this.showIdea = true
        })
        .catch(e => {
          console.error(e)
          this.showIdea = true
        })
    },
    showHideIdea: function () {
      if (!this.showIdea && this.ideaContent.length === 0) {
        this.loadIdea()
      } else {
        this.showIdea = !this.showIdea
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AbuseReportTableRow.vue